import {
    DRAFTS_LOADING,
    DRAFTS_LOADING_DISABLE,
    FETCH_DRAFTS_SUCCESS,
    CLEAR_DRAFTS_SUCCESS,
    FETCH_DRAFT_SUCCESS,
    FETCH_DRAFTS_DETAILS_SUCCESS,
    FETCH_ONLY_DRAFTS_DETAILS_SUCCESS,
    SET_DRAFT_STATUS_SUCCESS,
    SET_DRAFT_DETAIL_ROW_SUCCESS,
    DRAFT_WORKER_DELETE,
    DRAFT_WORKER_INSERT,
    DRAFT_WORKER_UPDATE,
    DRAFT_FIND_MISSING_WORKERS,
    DRAFT_WORKER_BULK_REPLACE,
    FETCH_SCHEDULE_REPORT_FIELDS,
    SCHEDULE_REPORT_FIELDS_LOADING
} from "actions/types";

const initialState = {
    drafts: [],
    draft: {},
    draftsDetails: [],
    draftsDetailsOptions: {},
    scheduleReportFields: [],
    scheduleReportLoading: false,
    loading: false
};

export default function (state = initialState, action) {
    let drafts,
        draftsDetails;
    switch (action.type) {
        case DRAFTS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case SCHEDULE_REPORT_FIELDS_LOADING:
            return {
                ...state,
                scheduleReportLoading: action.payload,
            };
        case FETCH_SCHEDULE_REPORT_FIELDS:
            return {
                ...state,
                scheduleReportFields: action.payload,
                scheduleReportLoading: false,
            };
        case DRAFTS_LOADING_DISABLE:
            return {
                ...state,
                loading: false
            };
        case FETCH_DRAFTS_SUCCESS:
            return {
                ...state,
                drafts: action.payload,
                loading: false
            };
        case CLEAR_DRAFTS_SUCCESS:
            return {
                ...state,
                // drafts: [],
                draft: {},
                draftsDetails: [],
                draftsDetailsOptions: {}
            };
        case FETCH_DRAFT_SUCCESS:
            return {
                ...state,
                draft: action.payload,
                loading: false
            };
        case FETCH_DRAFTS_DETAILS_SUCCESS:
            return {
                ...state,
                draftsDetails: action.payload.payload,
                draftsDetailsOptions: {
                    metadata: action.payload.metadata || state.draftsDetailsOptions.metadata,
                    pageNumber: action.payload.pageNumber,
                    pageSize: action.payload.pageSize,
                    totalFilteredRecords: action.payload.totalFilteredRecords,
                    totalRecords: action.payload.totalRecords,
                },
                loading: false
            };
        case FETCH_ONLY_DRAFTS_DETAILS_SUCCESS:
            return {
                ...state,
                draftsDetails: action.payload,
                loading: false
            };
        case SET_DRAFT_STATUS_SUCCESS:
            drafts = Object.assign([], state.drafts);
            Object.keys(drafts).forEach((key) => {
                if (drafts[key].id === action.payload.draftId) {
                    drafts[key] = action.payload.data;
                }
            });
            return {
                ...state,
                drafts,
                loading: false
            };
        case SET_DRAFT_DETAIL_ROW_SUCCESS:
            draftsDetails = Object.assign([], state.draftsDetails);
            draftsDetails.forEach((item, index) => {
                if (item.id === action.payload.draftDetailId) {
                    draftsDetails[index] = Object.assign({}, state.draftsDetails[index]);
                    draftsDetails[index][action.payload.field] = action.payload.value;
                }
            });
            return {
                ...state,
                draftsDetails,
                loading: false,
            };
        case DRAFT_WORKER_DELETE:
            draftsDetails = Object.assign([], state.draftsDetails);
            draftsDetails.forEach((value, index) => {
                if (value.id === action.payload.draftDetailRowId) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const workerIndex in draftsDetails[index].workers) {
                        // eslint-disable-next-line max-len
                        if (draftsDetails[index].workers[workerIndex].rowId === action.payload.workerRowId) {
                            draftsDetails[index] = Object.assign({}, state.draftsDetails[index]);
                            draftsDetails[index].worker =
                                Object.assign({}, state.draftsDetails[index].worker);
                            draftsDetails[index].workers.splice(workerIndex, 1);
                        }
                    }
                }
            });
            return {
                ...state,
                draftsDetails,
                loading: false,
            };
        case DRAFT_WORKER_INSERT:
            draftsDetails = Object.assign([], state.draftsDetails);
            draftsDetails.forEach((value, index) => {
                if (value.id === action.payload.draftDetailRowId) {
                    draftsDetails[index] = Object.assign({}, state.draftsDetails[index]);
                    draftsDetails[index].worker =
                        Object.assign({}, state.draftsDetails[index].worker);
                    if (action.payload.data.isTeamLead) {
                        draftsDetails[index].workers.unshift(action.payload.data);
                    } else {
                        draftsDetails[index].workers.push(action.payload.data);
                    }
                }
            });
            return {
                ...state,
                draftsDetails,
                loading: false,
            };
        case DRAFT_WORKER_UPDATE:
            draftsDetails = Object.assign([], state.draftsDetails);
            draftsDetails.forEach((value, index) => {
                if (value.id === action.payload.draftDetailRowId) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const workerIndex in draftsDetails[index].workers) {
                        // eslint-disable-next-line max-len
                        if (draftsDetails[index].workers[workerIndex].rowId === action.payload.workerRowId) {
                            draftsDetails[index] = Object.assign({}, state.draftsDetails[index]);
                            draftsDetails[index].worker =
                                Object.assign({}, state.draftsDetails[index].worker);
                            draftsDetails[index].workers[workerIndex] = action.payload.data;
                        }
                    }
                }
            });
            return {
                ...state,
                draftsDetails,
                loading: false,
            };
        case DRAFT_FIND_MISSING_WORKERS:
            // console.error("DRAFT_FIND_MISSING_WORKERS", action.payload);
            draftsDetails = Object.assign([], state.draftsDetails);
            action.payload.payload.forEach((newDraftDetail) => {
                draftsDetails.forEach((item, index) => {
                    if (item.id === newDraftDetail.id) {
                        draftsDetails[index] = newDraftDetail;
                    }
                });
            });
            return {
                ...state,
                draftsDetails,
                loading: false
            };
        case DRAFT_WORKER_BULK_REPLACE:
            // console.error("DRAFT_FIND_MISSING_WORKERS", action.payload);
            draftsDetails = Object.assign([], state.draftsDetails);
            action.payload.payload.forEach((newDraftDetail) => {
                draftsDetails.forEach((item, index) => {
                    if (item.id === newDraftDetail.id) {
                        draftsDetails[index] = newDraftDetail;
                    }
                });
            });
            return {
                ...state,
                draftsDetails,
                loading: false
            };
        default:
            return state;
    }
}
